import { render, staticRenderFns } from "./SquareStatistic.vue?vue&type=template&id=b44a67d6&scoped=true&"
import script from "./SquareStatistic.vue?vue&type=script&lang=js&"
export * from "./SquareStatistic.vue?vue&type=script&lang=js&"
import style0 from "./SquareStatistic.vue?vue&type=style&index=0&id=b44a67d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44a67d6",
  null
  
)

export default component.exports